export const createSelectDigitalBillUrl = (locationId: string, reference: string) => {
  if (window.location.pathname.includes('unsettled')) {
    return `/${locationId}/open-bill/unsettled/${reference}`;
  }
  return `/${locationId}/open-bill/settled/${reference}`;
};

export const createSelectUnsettledDigitalBillUrl = (locationId: string, reference: string) =>
  `/${locationId}/open-bill/unsettled/${reference}`;

export const createSelectSettledDigitalBillUrl = (locationId: string, reference: string) =>
  `/${locationId}/open-bill/settled/${reference}`;

export const createUnsettledDigitalBillURL = (locationId: string) => `/${locationId}/open-bill/unsettled`;

export const createCheckoutUrl = (locationId: string, reference: string) =>
  `/${locationId}/open-bill/unsettled/${reference}/checkout`;

export const createInviteGuestUrl = (locationId: string, reference: string) =>
  `/${locationId}/open-bill/unsettled/${reference}/invite-guest`;

export const createDigitalBillOverviewUrl = (locationId: string) => `/${locationId}/open-bill/unsettled`;
export const createSettledBillsUrl = (locationId: string) => `/${locationId}/open-bill/settled`;

export const createMenuUrl = (locationId: string) => `/${locationId}`;

export const createCartUrl = (locationId: string) => `/${locationId}/cart`;

export const createCreateBillUrl = (locationId: string, primaryReference?: string) => {
  const referencePath = primaryReference ? `/${primaryReference}` : '';
  return `${createUnsettledDigitalBillURL(locationId)}/create${referencePath}`;
};

export const createTerminalModeUrl = (locationId: string) => `/${locationId}/terminal-mode`;

export const createTableMapBuilderUrl = (locationId: string, zoneId?: string) =>
  `/${locationId}/table-map-builder/${zoneId}`;
